import { gql } from '@apollo/client';

export const UploadText = gql`
    mutation uploadText($text: String!, $agentId: ID!) {
        uploadText(text: $text, agentId: $agentId) {
            ... on UploadedKnowledgeDataSuccessType {
                message
                knowledgeData {
                    id
                    source
                    active
                    sourceType
                    text
                    createdAt
                }
            }
            ... on ErrorType {
                message
            }
        }
    }
`;
